import { usePresentationGuideStore } from "@/stores/presentation-guide-store";

type PresentationGuideState = ReturnType<
  typeof usePresentationGuideStore.getState
>;

/** The presentation whose guide is currently open. */
export function activeGuidePresentationId(
  state: PresentationGuideState,
): string | null {
  return state.guide?.presentationId ?? null;
}

/** The presentation whose guide is currently open, read during render. */
export function useActiveGuidePresentationId(): string | null {
  return usePresentationGuideStore(activeGuidePresentationId);
}
